import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import Link from "../../../basics/Link"
import { router } from "../../../../utility/router"
import { PageContext } from "../../Page"

import EcosystemIcon from '../../../../assets/icons/header/ecosystem.svg'
import HistoryIcon from '../../../../assets/icons/header/history.svg'
import ManagementIcon from '../../../../assets/icons/header/management.svg'
import MissionIcon from '../../../../assets/icons/header/mission.svg'
import PlatformIcon from '../../../../assets/icons/header/platform.svg'

import OurTeamIcon from '../../../../assets/icons/header/team.svg'
import WhyFabrickIcon from '../../../../assets/icons/header/why.svg'
import JoinUsIcon from '../../../../assets/icons/header/join.svg'

const MenuAboutFabrick = ({ closeMenuFunction = () => { } }) => {
  const context = useContext(PageContext)
  const [t] = useTranslation("layout")

  return <>
    <div className="h-full px-5 pt-5 pb-3.5 col-span-1 border-r">
      <h5 className="text-blue-10 mb-2">{t('header.corporate')}</h5>
      <div className="flex items-center mb-1.5">
        <EcosystemIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('aboutFabrick.ecosystem', context.folder)} className="text-xs ml-1.5 block " onClick={() => closeMenuFunction()}>
          {t('header.aboutFabrickMenu.ecosystem')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <HistoryIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('aboutFabrick.history', context.folder)} className="text-xs ml-1.5 block" onClick={() => closeMenuFunction()}>
          {t('header.aboutFabrickMenu.history')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <ManagementIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('aboutFabrick.mission', context.folder)} className="text-xs ml-1.5 block" onClick={() => closeMenuFunction()}>
          {t('header.aboutFabrickMenu.mission')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <MissionIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('aboutFabrick.team', context.folder)} className="text-xs ml-1.5 block" onClick={() => closeMenuFunction()}>
          {t('header.aboutFabrickMenu.team')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <PlatformIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('aboutFabrick.platform', context.folder)} className="text-xs ml-1.5 block" onClick={() => closeMenuFunction()}>
          {t('header.aboutFabrickMenu.platform')}
        </Link>
      </div>
    </div>

    <div className="h-full px-5 pt-5 pb-3.5 col-span-1 border-r">
      <h5 className="text-blue-10 mb-2">{t('header.fabrickPeople')}</h5>
      <div className="flex items-center mb-1.5">
        <OurTeamIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('fabrickPeople.ourTeam', context.folder)} className="text-xs block ml-1.5" onClick={() => closeMenuFunction()}>
          {t('footer.ourTeam')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <WhyFabrickIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('fabrickPeople.whyFabrick', context.folder)} className="text-xs block ml-1.5" onClick={() => closeMenuFunction()}>
          {t('footer.whyFabrick')}
        </Link>
      </div>
      <div className="flex items-center mb-1.5">
        <JoinUsIcon className="min-w-[40px] min-h-[40px]" />
        <Link to={router('fabrickPeople.joinUs', context.folder)} className="text-xs block ml-1.5" onClick={() => closeMenuFunction()}>
          {t('footer.openPositions')}
        </Link>
      </div>
    </div>

    <div className="h-full px-5 pt-5 pb-3.5 col-span-1">
      <h5 className="text-blue-10 mb-3">{t('header.mediaHub')}</h5>
      <Link to={router('mediaHub.pressReleases', context.folder)} className="text-[16px]/[16px] font-bold text-midnight-10 pb-1.5 block" onClick={() => closeMenuFunction()}>{t('header.pressReleases')}</Link>
      <Link to={router('mediaHub.pressReview', context.folder)} className="text-[16px]/[16px] font-bold text-midnight-10 py-1.5 block" onClick={() => closeMenuFunction()}>{t('header.pressReview')}</Link>
      <Link to={router('mediaHub.events', context.folder)} className="text-[16px]/[16px] font-bold text-midnight-10 py-1.5 block" onClick={() => closeMenuFunction()}>{t('header.events')}</Link>
      <Link to={router('mediaHub.mediaKit', context.folder)} className="text-[16px]/[16px] font-bold text-midnight-10 py-1.5 block" onClick={() => closeMenuFunction()}>{t('header.mediaKit')}</Link>
    </div>
  </>
}

export default MenuAboutFabrick